import styled from '@emotion/styled';
import { Card } from 'imdui';

export const LibraryWrap = styled(Card)`
  // background-color: #f8f8f8;
`;
